import { render, staticRenderFns } from "./meet-team.vue?vue&type=template&id=07bc5f74&scoped=true&"
import script from "./meet-team.vue?vue&type=script&lang=js&"
export * from "./meet-team.vue?vue&type=script&lang=js&"
import style0 from "./meet-team.vue?vue&type=style&index=0&id=07bc5f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc5f74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07bc5f74')) {
      api.createRecord('07bc5f74', component.options)
    } else {
      api.reload('07bc5f74', component.options)
    }
    module.hot.accept("./meet-team.vue?vue&type=template&id=07bc5f74&scoped=true&", function () {
      api.rerender('07bc5f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/meet-team.vue"
export default component.exports